const reservationHelper = (data) => {
    return data.map(reservation => {
        reservation.start = reservation.dockingStartDateTime
        reservation.end = reservation.dockingEndDateTime
        reservation.duration = (new Date(reservation.end).getTime() - new Date(reservation.start).getTime()) / 1000 / 60
        reservation.icon = reservation.dockReservationStatusId === 10 ? 'mdi-circle' : ''
        reservation.textColor = 'white'
        reservation.backgroundColor= reservation.dock.dockTypeId === 10 ? '#FF8A80' : '#4DB6AC'
        reservation.resourceId = reservation.dock.id
        if (!data.dockType) {
            if (reservation.firstName && reservation.lastName) reservation.title = `${(reservation.customer.name)}, ${reservation.firstName} ${reservation.lastName}, ${reservation.plateNumber}, palet:${reservation.palletsQuantity}`
            if (!reservation.firstName && reservation.lastName) reservation.title = `${(reservation.customer.name)}, ${reservation.lastName}, ${reservation.plateNumber}, palet:${reservation.palletsQuantity}`
            if (!reservation.lastName) reservation.title = `${(reservation.customer.name)}, ${reservation.plateNumber}, palet:${reservation.palletsQuantity}`
        }
        if (data.dockType) {
            reservation.title = `${(reservation.customer.name).substring(0, 15)}...`
            reservation.description = `${reservation.customer.name}, palet:${reservation.palletsQuantity}`
        }

        return reservation
    })
}

export default {
    GET_DOCK_RESERVATIONS_SUCCESS: (state, data) => {
        state.dockReservations = reservationHelper(data.reservations)
    },
    GET_DOCK_CLIPBOARD_RESERVATIONS_SUCCESS: (state, data) => {
        state.dockClipboardReservations = reservationHelper(data.reservations)
    },
    SET_BUSINESS_HOURS: (state, payload) => {
        state.docks.map(dock => {
            payload.weekRange.forEach(week => {
                payload.data[week].forEach(dateRange => {
                    if (dock.id === payload.dockId) {
                        dock.businessHours.push(
                            {
                                daysOfWeek: [(new Date(dateRange.start.split('T')[0]).getDay())],
                                startTime: new Date(dateRange.start).toLocaleTimeString(),
                                endTime: new Date(dateRange.end).toLocaleTimeString() === '00:00:00' ? '24:00:00' : new Date(dateRange.end).toLocaleTimeString(),
                            }
                        )
                    }
                })
            })
        })
    },
    CLEAR_BUSINESS_HOURS: (state) => {
        state.docks.forEach(item => {
            item.businessHours = []
        })
        state.dockReservations = []
    },
    SET_USER_DATA: (state, data) => {
        state.user = data
    },
    SET_AVAILABLE_HOURS_FOR_SELECTED_DAY: (state, payload) => {
        state.availableHoursForSelectedDay = []
        payload.data[payload.selectedDate].forEach(date => state.availableHoursForSelectedDay.push(date))
    },
    CLEAR_AVAILABLE_HOURS_FOR_SELECTED_DAY: state => {
        state.availableHoursForSelectedDay = []
    },
    GET_DOCKS_DICTS_SUCCESS: (state, data) => {
        data.forEach(item => {
            item.title = item.name
            item.businessHours = []
            state.docks.push(item)
        })
    },
    GET_DOCKS_REQUEST: (state) => {
        state.docksLoading = true
    },
    GET_DOCKS_SUCCESS: (state, data) => {
        state.docks = data
        state.docksLoading = false
    },
    GET_DOCKS_FAILURE: (state) => {
        state.docksLoading = false
    },
    GET_DOCK_TYPES_SUCCESS: (state, data) => {
        state.dockTypes = data
    },
    CLEAR_DOCKS: state => {
        state.docks = []
    },
    CLEAR_DOCK_TYPES: state => {
        state.dockTypes = []
    },
    GET_RESERVATION_STATUSES_SUCCESS: (state, data) => {
        state.dockReservationStatuses = data
    },
    GET_STORES_REQUEST: (state) => {
        state.docksLoading = true
    },
    GET_STORES_SUCCESS: (state, data) => {
        state.stores = data
        state.storesLoading = false
    },
    GET_STORES_FAILURE: (state) => {
        state.storesLoading = false
    },

}